import { Button, Title } from "@mantine/core";
import "./ErrorFallback.scss";

function ErrorFallback({ resetErrorBoundary }) {
  return (
    <div className="ErrorFallbackContainer" role="alert">
      <Title maw={400} mb="1em" order={2}>
        Beim Laden der Seite ist ein Fehler aufgetreten.
      </Title>

      <p>
        Wir entschuldigen uns für die Unannehmlichkeiten. Bitte versuchen Sie,
        die Seite neu zu laden.
      </p>
      <Button color="secondary" onClick={resetErrorBoundary}>
        Neu laden
      </Button>
    </div>
  );
}

export { ErrorFallback };
